/* ============================================================
   LIQUIDSHOP HEADER v2 "COMMAND BAR" — JS vanilla (aucune dépendance)
   Les libellés EN/FR sont rendus côté serveur (Liquid | t) ;
   le toggle EN|FR navigue vers l'URL localisée (/fr prefix).
   ============================================================ */
(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var header = $('.header');
  if (!header) return;

  var burger = $('.burger'),
    drawer = $('.menu_second'),
    overlay = $('.overlay'),
    drawerClose = $('.menu_second__close'),
    searchToggle = $('.search-container__toggle'),
    searchForm = $('.search-container__form'),
    searchClose = $('.search-container__close'),
    searchInput = $('.search-container__input'),
    subItem = $('.menu__item--has-sub'),
    subBtn = $('.menu__item--has-sub > .menu__lien'),
    cartLink = $('.header__cart'),
    cartDrawer = $('.cart-drawer'),
    badge = $('[data-cart-badge]');

  /* ---- Langue EN|FR : navigation vers l'URL localisée ---- */
  var isFrench = window.location.pathname === '/fr' || window.location.pathname.indexOf('/fr/') === 0;
  function goLang(l) {
    if ((l === 'fr') === isFrench) return;
    var path = window.location.pathname;
    var newPath;
    if (l === 'fr') {
      newPath = '/fr' + (path === '/' ? '' : path);
    } else {
      newPath = path.replace(/^\/fr(\/|$)/, '/');
    }
    if (!newPath) newPath = '/';
    window.location.href = window.location.origin + newPath + window.location.search + window.location.hash;
  }
  $$('.header__lang-btn').forEach(function (b) {
    b.addEventListener('click', function () { goLang(b.getAttribute('data-lang')); });
  });

  /* ---- Search (barre de commande) ---- */
  function openSearch(focus) {
    header.classList.add('header--search-open');
    searchToggle.setAttribute('aria-expanded', 'true');
    closeSub();
    if (focus !== false) setTimeout(function () { searchInput.focus(); }, 260);
  }
  function closeSearch() {
    header.classList.remove('header--search-open');
    searchToggle.setAttribute('aria-expanded', 'false');
    hideSuggest();
  }
  function searchIsOpen() { return header.classList.contains('header--search-open'); }
  if (searchToggle) {
    searchToggle.addEventListener('click', function () { searchIsOpen() ? closeSearch() : openSearch(); });
    searchClose.addEventListener('click', function () { closeSearch(); searchToggle.focus(); });
    /* raccourci "/" */
    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && !searchIsOpen() && !(drawer && drawer.classList.contains('is-open'))) {
        var t = document.activeElement && document.activeElement.tagName;
        if (t !== 'INPUT' && t !== 'TEXTAREA') { e.preventDefault(); openSearch(); }
      }
    });
  }

  /* ---- Autocompletion maison (API Predictive Search de Shopify) ----
     Remplace Searchanise : plan gratuit depasse (68 produits > 25), textes non
     traduisibles. Le champ n'a pas de name="q" (voir header-pagecustom.liquid) :
     l'envoi est construit ici, vers /search ou /fr/search. */
  var sgBox = $('#search-suggest');
  var sgTimer = null, sgSeq = 0, sgActive = -1, sgItems = [];

  function sgRoot() {
    /* pages FR en cache : Shopify.routes.root vaut "/" -> prefixe pose par theme.liquid */
    if (window.__lsLocalePrefix) return window.__lsLocalePrefix + '/';
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function sgLabel(key, q) {
    var t = (searchForm && searchForm.getAttribute('data-sg-' + key)) || '';
    return q == null ? t : t.replace('{q}', q);
  }
  function sgMoney(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return new Intl.NumberFormat(cartLocale(), { style: 'currency', currency: 'CAD' }).format(n);
  }
  function searchUrl(q) {
    return sgRoot() + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }
  function hideSuggest() {
    if (!sgBox) return;
    sgBox.hidden = true;
    sgBox.innerHTML = '';
    sgItems = []; sgActive = -1;
    if (searchInput) {
      searchInput.setAttribute('aria-expanded', 'false');
      searchInput.removeAttribute('aria-activedescendant');
    }
  }
  function sgSetActive(i) {
    sgItems.forEach(function (el, k) { el.classList.toggle('is-active', k === i); el.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    sgActive = i;
    if (i >= 0 && sgItems[i]) {
      searchInput.setAttribute('aria-activedescendant', sgItems[i].id);
      sgItems[i].scrollIntoView({ block: 'nearest' });
    } else {
      searchInput.removeAttribute('aria-activedescendant');
    }
  }
  /* Shopify tolere les fautes : « taur » remontait aussi Sucralose ou Acesulfame K.
     Si des produits contiennent vraiment chaque mot tape (debut de mot, sans accents),
     on ne garde qu'eux ; sinon on garde l'approximation (utile sur une faute de frappe). */
  function sgFold(v) {
    return String(v || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function sgStrict(q, list) {
    var words = sgFold(q).split(/\s+/).filter(Boolean);
    var hits = list.filter(function (p) {
      var hay = ' ' + sgFold(p.title).replace(/[^a-z0-9]+/g, ' ');
      return words.every(function (w) { return hay.indexOf(' ' + w) !== -1; });
    });
    return hits.length ? hits : list;
  }
  /* Rendu serveur (sections/search-suggest.liquid) : Shopify connait le client connecte,
     donc le prix suit la regle B2B/B2C des cartes produit. Ici : filtre de pertinence sur
     les titres, formatage des montants (EN/FR), ids pour la navigation clavier. */
  /* v2 : rendu serveur B2B/B2C (sections/search-suggest.liquid) */
  function sgRender(q, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var inner = doc.querySelector('.search-suggest__inner');
    if (!inner) { hideSuggest(); return; }
    var prods = Array.prototype.slice.call(inner.querySelectorAll('.search-suggest__opt--product'));
    var keep = sgStrict(q, prods.map(function (el) { return { title: el.getAttribute('data-title') || '', el: el }; }));
    prods.forEach(function (el) {
      if (!keep.some(function (k) { return k.el === el; })) el.parentNode.removeChild(el);
    });
    inner.querySelectorAll('.search-suggest__price[data-cents]').forEach(function (el) {
      var cents = parseInt(el.getAttribute('data-cents'), 10);
      if (!isNaN(cents)) el.textContent = sgLabel('from').replace('{p}', sgMoney(cents / 100));
    });
    sgBox.innerHTML = inner.innerHTML;
    sgItems = Array.prototype.slice.call(sgBox.querySelectorAll('[role="option"]'));
    sgItems.forEach(function (el, i) { el.id = 'sg-opt-' + i; });
    sgActive = -1;
    sgBox.hidden = false;
    searchInput.setAttribute('aria-expanded', 'true');
  }
  function sgFetch(q) {
    var seq = ++sgSeq;
    var url = sgRoot() + 'search/suggest?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product,collection,article&resources%5Blimit%5D=6' +
      '&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
      '&resources%5Boptions%5D%5Bfields%5D=title,product_type,tag,variants.title&section_id=search-suggest';
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (seq !== sgSeq || !searchIsOpen() || !html) return; /* reponse perimee */
        sgRender(q, html);
      })
      .catch(function () { /* reseau : Entree reste fonctionnelle */ });
  }
  if (searchForm && searchInput && sgBox) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(sgTimer);
      if (q.length < 2) { sgSeq++; hideSuggest(); return; }
      sgTimer = setTimeout(function () { sgFetch(q); }, 180);
    });
    searchInput.addEventListener('keydown', function (e) {
      if (!sgItems.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); sgSetActive((sgActive + 1) % sgItems.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); sgSetActive(sgActive <= 0 ? sgItems.length - 1 : sgActive - 1); }
    });
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sgActive >= 0 && sgItems[sgActive]) { window.location.href = sgItems[sgActive].href; return; }
      var q = searchInput.value.trim();
      if (!q) return;
      window.location.href = searchUrl(q);
    });
  }

  /* ---- Mega-menu (hover = CSS ; clic/tap = toggle) ---- */
  /* is-dismissed : le panneau s'ouvre aussi sur :focus-within (CSS). Apres Escape le focus
     reste sur le bouton, donc sans cet etat le panneau restait visible alors que
     aria-expanded repassait a false (audit a11y 2026-09-28). Leve quand le focus quitte
     le menu, a la sortie de la souris ou a la reouverture. */
  function closeSub() {
    if (!subItem) return;
    subItem.classList.remove('is-open');
    subItem.classList.add('is-dismissed');
    subBtn.setAttribute('aria-expanded', 'false');
  }
  if (subItem) {
    subItem.addEventListener('focusout', function (e) {
      if (!subItem.contains(e.relatedTarget)) subItem.classList.remove('is-dismissed');
    });
    subItem.addEventListener('mouseleave', function () { subItem.classList.remove('is-dismissed'); });
  }
  if (subBtn) {
    subBtn.addEventListener('click', function () {
      subItem.classList.remove('is-dismissed');
      var open = subItem.classList.toggle('is-open');
      subBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Focus : helpers partages drawer + mini-cart ----
     Les deux sont des dialogues modaux (overlay + <html class="is-locked">). Sans piege,
     Tab s'echappe vers la page derriere : mesure avant fix, 7 tabulations sur 14 sortaient
     du drawer vers le skip-link et le header. */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]),' +
    ' textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), shopify-account';
  /* shopify-account est focusable via delegatesFocus : il n'a ni href ni tabindex, donc
     aucun selecteur standard ne le voit, alors qu'il EST dans l'ordre de tabulation reel
     (mesure : 7e position dans le drawer). L'omettre fausserait le calcul du dernier element. */
  function focusables(container) {
    return $$(FOCUSABLE, container).filter(function (el) {
      if (el.closest('[inert]')) return false; /* sous-menus replies de l'accordeon */
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }
  /* Recalcule a chaque Tab plutot que de mettre en cache : le contenu du mini-cart est
     re-rendu par refreshCart(), et l'accordeon change l'etat inert de ses sous-menus. */
  function trapTab(container, e) {
    var f = focusables(container);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey) {
      if (a === first || !container.contains(a)) { e.preventDefault(); last.focus(); }
    } else {
      if (a === last || !container.contains(a)) { e.preventDefault(); first.focus(); }
    }
  }
  /* Un sheet <shopify-account> ouvert gere lui-meme Tab (dialog natif) et Escape. Sans ce
     test, un seul Escape fermait le sheet ET le drawer derriere. Le shadow root est ouvert
     (le theme y injecte deja du CSS, cf. menu compte signed-out) donc dialog[open] est
     lisible ; si Shopify le fermait un jour, shadowRoot vaut null et on degrade sans casser. */
  function accountDialogOpen() {
    return $$('shopify-account').some(function (el) {
      return !!(el.shadowRoot && el.shadowRoot.querySelector('dialog[open]'));
    });
  }
  /* .menu_second et .cart-drawer sont visibility:hidden avec une transition .3s : au moment
     de l'appel synchrone la visibilite calculee vaut encore hidden, donc .focus() est un
     no-op silencieux (mesure : activeElement restait BODY, meme 500 ms apres). Un frame
     plus tard la transition a demarre et l'element est focusable. */
  function focusWhenVisible(get) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        /* resolution tardive : le contenu du mini-cart peut etre re-rendu entre l'appel
           et le frame, un noeud capture d'avance serait detache donc infocusable */
        var el = typeof get === 'function' ? get() : get;
        if (el) el.focus();
      });
    });
  }

  /* ---- Drawer mobile ---- */
  function openDrawer(focus) {
    if (!drawer || !overlay || !burger) return;
    drawer.classList.add('is-open'); overlay.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('is-locked');
    if (focus !== false) focusWhenVisible(drawerClose);
  }
  function closeDrawer(refocus) {
    if (!drawer || !overlay || !burger) return;
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('is-locked');
    if (refocus !== false) burger.focus();
  }
  if (burger && drawer && overlay) {
    burger.addEventListener('click', function () { openDrawer(); });
    drawerClose.addEventListener('click', function () { closeDrawer(); });
    overlay.addEventListener('click', function () { closeDrawer(false); closeCart(false); });
  }

  /* ---- Mini-cart slide-in droite ---- */
  function openCart(focus) {
    /* Garde symetrique de closeCart : openCart est expose via window.LSHeader et appele
       depuis testcollection.liquid, donc hors du garde `if (cartLink && cartDrawer)`. */
    if (!cartDrawer || !cartLink) return;
    cartDrawer.classList.add('is-open'); overlay.classList.add('is-open');
    cartLink.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('is-locked');
    if (focus !== false) {
      focusWhenVisible(function () { return $('.cart-drawer__close', cartDrawer); });
    }
  }
  function closeCart(refocus) {
    if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;
    cartDrawer.classList.remove('is-open');
    if (!drawer || !drawer.classList.contains('is-open')) overlay.classList.remove('is-open');
    cartLink.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('is-locked');
    if (refocus !== false) cartLink.focus();
  }
  if (cartLink && cartDrawer) {
    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      cartDrawer.classList.contains('is-open') ? closeCart() : openCart();
    });
    /* délégation : le bouton close est remplacé quand le drawer est re-rendu */
    cartDrawer.addEventListener('click', function (e) {
      if (e.target.closest('.cart-drawer__close')) closeCart();
    });
  }

  /* ---- Accordéon Ingredients dans le drawer ---- */
  $$('[data-accordion]').forEach(function (g) {
    var btn = $('.menu_second__lien', g);
    var sub = $('.menu_second__sub', g);
    /* replié : max-height:0 + overflow:hidden laisse les liens tabbables → inert */
    if (sub) sub.inert = true;
    btn.addEventListener('click', function () {
      var open = g.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (sub) sub.inert = !open;
    });
  });

  /* ---- Fermetures globales ---- */
  document.addEventListener('click', function (e) {
    if (subItem && subItem.classList.contains('is-open') && !subItem.contains(e.target)) closeSub();
    if (searchIsOpen() && !searchForm.contains(e.target) && !searchToggle.contains(e.target)) closeSearch();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    /* le sheet compte est au-dessus : il consomme Escape, on ne ferme pas la couche dessous */
    if (accountDialogOpen()) return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
    else if (drawer && drawer.classList.contains('is-open')) closeDrawer();
    else if (searchIsOpen()) { closeSearch(); searchToggle.focus(); }
    else if (subItem && (subItem.classList.contains('is-open') || subItem.contains(document.activeElement))) {
      closeSub();
      if (subItem.contains(document.activeElement)) subBtn.focus();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    /* un <dialog> natif ouvert piege deja Tab lui-meme : ne pas lui disputer le focus */
    if (accountDialogOpen()) return;
    if (cartDrawer && cartDrawer.classList.contains('is-open')) trapTab(cartDrawer, e);
    else if (drawer && drawer.classList.contains('is-open')) trapTab(drawer, e);
  });

  /* ---- Resize vers desktop : ferme le drawer mobile (sinon body reste locké) ---- */
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1023 && drawer && drawer.classList.contains('is-open')) closeDrawer(false);
  }, { passive: true });

  /* ---- Sticky : cache au scroll down, revient au scroll up + compact ---- */
  var lastY = window.scrollY || 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY || 0;
    header.classList.toggle('header--scrolled', y > 24);
    var down = y > lastY;
    if (down && y > 160 && !searchIsOpen() && !header.contains(document.activeElement)) {
      header.classList.add('header--hidden');
    } else if (!down || y <= 160) {
      header.classList.remove('header--hidden');
    }
    lastY = y;
  }, { passive: true });

  /* ---- Badge panier (pour mises à jour AJAX éventuelles) ---- */
  function setCart(n) {
    n = parseInt(n, 10) || 0;
    if (badge) {
      badge.textContent = n > 99 ? '99+' : String(n);
      badge.style.display = n === 0 ? 'none' : 'grid';
    }
    var c = $('[data-cart-count]');
    if (c) c.textContent = '/ ' + (n < 10 ? '0' + n : n);
  }
  /* resynchronise badge + contenu du mini-cart après un add-to-cart AJAX.
     Section Rendering API : re-rend la section header côté serveur et on en
     extrait le drawer frais. Fallback badge-only via /cart.js. Retourne une Promise. */
  function refreshCart() {
    var sid = cartDrawer && cartDrawer.getAttribute('data-section-id');
    if (!sid) {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCart(cart.item_count); })
        .catch(function () {});
    }
    /* préfixe de locale (ex. /fr/) : sans lui, la section serait re-rendue en EN sur les pages FR */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[sid];
        if (!html) throw new Error('empty section');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-drawer');
        if (fresh) cartDrawer.innerHTML = fresh.innerHTML;
        var b = doc.querySelector('[data-cart-badge]');
        if (b) setCart(b.textContent);
      })
      .catch(function () {
        /* fallback : au moins le badge */
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { setCart(cart.item_count); })
          .catch(function () {});
      });
  }

  /* ---- Mini-cart : stepper de quantite + recapitulatif ----
     Tout passe par la DELEGATION sur cartDrawer / document : refreshCart()
     remplace cartDrawer.innerHTML, donc un listener attache a un noeud interne
     mourrait au premier changement de quantite. L'aside, lui, survit. */
  var cartPending = false;

  function cartLocale() {
    return (document.documentElement.lang || 'en').toLowerCase().indexOf('fr') === 0 ? 'fr-CA' : 'en-CA';
  }
  function cartMoney(amount) {
    return new Intl.NumberFormat(cartLocale(), { style: 'currency', currency: 'CAD' }).format(amount);
  }

  /* Montant de livraison estime, memorise entre deux refresh du drawer : le
     widget n'est pas force de re-emettre si l'utilisateur ne retouche pas le
     select, mais le total doit rester juste apres un changement de quantite. */
  var cartShipAmount = null;

  function cartSubtotalCents() {
    if (!cartDrawer) return 0;
    var src = cartDrawer.querySelector('[data-cart-total-cents]');
    return src ? parseInt(src.getAttribute('data-cart-total-cents'), 10) || 0 : 0;
  }
  /* Reecrit le sous-total SSR (format money global de la boutique, ex. "$1,018.85")
     au format Intl fr-CA/en-CA, pour rester coherent avec livraison et total. */
  function renderCartSummary() {
    if (!cartDrawer) return;
    var cents = cartSubtotalCents();
    var sub = cartDrawer.querySelector('[data-cd-subtotal]');
    if (sub && cents > 0) sub.textContent = cartMoney(cents / 100);
    var tot = cartDrawer.querySelector('[data-cd-esttotal]');
    if (tot) {
      tot.textContent = cartMoney(cents / 100 + (typeof cartShipAmount === 'number' ? cartShipAmount : 0));
    }
  }
  /* Le custom element a pu rendre (et emettre) avant l'attache du listener, ou
     avant un refresh du drawer : rejouer un render pour recuperer le montant. */
  function replayShipWidget() {
    if (!cartDrawer) return;
    var w = cartDrawer.querySelector('.cart-ship-widget shipping-estimate');
    if (w && typeof w.render === 'function' && w.select) w.render();
  }

  /* Delegation sur document : le widget vit dans le drawer re-rendu, et l'event
     bouillonne jusqu'ici. */
  document.addEventListener('shipping-estimate:update', function (e) {
    if (!cartDrawer || !e.target || !cartDrawer.contains(e.target)) return;
    cartShipAmount = e.detail.amount;
    var line = cartDrawer.querySelector('[data-cd-ship]');
    if (line) line.textContent = e.detail.formatted;
    renderCartSummary();
  });

  function changeCartLine(lineEl, key, quantity) {
    cartPending = true;
    lineEl.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart change failed: ' + res.status);
        return res.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () {
        replayShipWidget();
        renderCartSummary();
      })
      .catch(function () { lineEl.classList.remove('is-updating'); })
      .then(function () { cartPending = false; });
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cd-action]');
      if (!btn) return;
      e.preventDefault();
      if (cartPending) return;
      var lineEl = btn.closest('.cart-drawer__item');
      if (!lineEl) return;
      var key = lineEl.getAttribute('data-key');
      if (!key) return;
      var qtyEl = lineEl.querySelector('[data-cd-qty]');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
      var action = btn.getAttribute('data-cd-action');
      var next;
      if (action === 'plus') next = current + 1;
      else if (action === 'minus') next = Math.max(0, current - 1);
      else next = 0;
      if (next === current) return;
      changeCartLine(lineEl, key, next);
    });
    /* Premier chargement : le widget a pu emettre pendant le parsing. */
    replayShipWidget();
    renderCartSummary();
  }

  window.LSHeader = {
    openSearch: openSearch, closeSearch: closeSearch,
    openDrawer: openDrawer, closeDrawer: closeDrawer,
    openCart: openCart, closeCart: closeCart,
    setCart: setCart, refreshCart: refreshCart
  };
})();
